module.exports = __webpack_public_path__ + "img/fraud-6.bbbb2335.jpg";